<template>
  <pdl-dialog
    id="compareRackDialog"
    :visible="compareRackDialogVisible"
    :z-index="16000011"
    :close-dialog-tool-tip="$t('popup.close')"
    qaid="compare-rack-dialog"
    :fullscreen="viewBreakpointLessThan('medium')"
    custom-class="compare-rack-dialog"
    @close="closeCompareRackDialog"
    @opened="focusTrapRackDialog"
    @keydown="handleKeydown"
  >
    <template #title>
      <pdl-section-header size="lg" qaid="compareRackHeaderContainer">
        <template #content>
          <pdl-heading id="compareRackDialog-title" qaid="compareRackHeader" level="1">
            {{ $t('productCompare.rack') }}
          </pdl-heading>
        </template>
        <template #actions>
          <pdl-link
            button
            primary
            small
            :href="`${encodedContextPath}/compare/`"
            class="hidden lg:inline-block"
            qaid="compareRackStartComparisonButton"
          >
            {{ $t('productCompare.startComparison') }}
          </pdl-link>
        </template>
      </pdl-section-header>
    </template>
    <compare-rack></compare-rack>
  </pdl-dialog>
</template>
<script>
import CompareRack from '@/components/containers/plp/CompareRack';
import {focusTrap, getAllFocusableElements} from '@/utils/accessibility/a11y-utils';
import {PdlDialog} from '@pedal/pdl-dialog';
import {PdlLink} from '@pedal/pdl-link';
import {PdlSectionHeader, PdlHeading} from '@pedal/pdl-section-header';
import {mapGetters, mapState} from 'vuex';

export default {
  components: {CompareRack, PdlLink, PdlDialog, PdlSectionHeader, PdlHeading},

  data() {
    return {
      focusableElements: [],
    };
  },

  computed: {
    ...mapState('compare', ['compareRackDialogVisible']),
    ...mapGetters('viewSize', ['viewBreakpointLessThan']),
    ...mapState('backend', ['encodedContextPath']),
  },

  created() {
    this.closeCompareRackDialog();
  },

  methods: {
    closeCompareRackDialog() {
      this.$store.commit('compare/setCompareRackDialog', false);
    },
    focusTrapRackDialog() {
      const dialog = document.querySelector('.compare-rack-dialog');
      this.focusableElements = getAllFocusableElements(dialog);
    },
    handleKeydown(event) {
      focusTrap(event, this.focusableElements);
    },
  },
};
</script>

<style scoped lang="scss">
//duplicating custom class selector to avoid use of pedal component class for styling
:deep(.compare-rack-dialog.compare-rack-dialog) {
  width: 100%;
  max-width: 75rem;
}
</style>
